// This is the javascript entrypoint for the featured-collection section.
// This file and all its inclusions will be processed through postcss

class ProductAddonEPA extends HTMLElement {
    constructor() {
      super();
      this.showMore = this.querySelector('.products-epa-showmore');
      this.products = this.querySelectorAll('.grid-item');

      this.showMore.addEventListener('click', this.toggleShowMore.bind(this));
      this.selectorsVariant = this.querySelectorAll('.product-single__variants');
      Array.from(this.selectorsVariant).forEach(function(selector){
        selector.addEventListener('change', this.changeVariantHandler.bind(this));
      }, this);
      
    }
  
    toggleShowMore(e) {
      e.preventDefault();
      if(e.target.classList.contains('is-showmore')) {
        Array.from(this.products).forEach(function(product, index){
          if(index > 1 && !product.classList.contains('hide-expand')) {
            product.classList.add('hide-expand');
          }
        });
        e.target.classList.remove('is-showmore');
        e.target.innerText = 'Show more';
      }else {
        Array.from(this.products).forEach(function(product, index){
          if(product.classList.contains('hide-expand')) {
            product.classList.remove('hide-expand');
          }
        });
        e.target.classList.add('is-showmore');
        e.target.innerText = 'Show less';
      }
    }
    changeVariantHandler(e) {
      let parent = e.target.closest('.grid-item__meta');
      this.copyVariantIdToPlaceholder(e, parent);
      this.changePrice(e, parent);
    }
    copyVariantIdToPlaceholder(e, parent) {
      let variantID = e.target.value;
      
      let variantPlaceholderInput = parent.querySelector('.selector_variant-placeholder');
      variantPlaceholderInput.value = variantID;
    }
    changePrice(e, parent) {
      let price = e.target.options[e.target.selectedIndex].dataset.price;
      let variant_price = parent.querySelector('.variant-price');
      variant_price.innerText = price;
    }
}
  
customElements.define('product-epa-addon', ProductAddonEPA);